import {Provider} from "@/components/ui/provider"
import AppContent from "@/AppContent";
import {BrowserRouter} from "react-router-dom";
import ChatProvider from "@/components/providers/ChatProvider";
import {EndpointProvider} from "@/components/providers/EndpointProvider";
import {WorkerProvider} from "@/components/providers/WorkerProvider";
import r2tChatConfig from "@/clients/r2t/chatConfig";

function App() {
    return (
        <Provider>
            <ChatProvider config={r2tChatConfig}>
                <EndpointProvider>
                    <WorkerProvider>
                        <BrowserRouter>
                            <AppContent/>
                        </BrowserRouter>
                    </WorkerProvider>
                </EndpointProvider>
            </ChatProvider>
        </Provider>
    )
}

export default App;


